/**
 * Shared formatting utilities for all accounting pages.
 */

export const formatCurrency = (amount, opts = {}) => {
  const num = typeof amount === 'string' ? parseFloat(amount) : (amount || 0);
  const formatted = num.toLocaleString('en-AE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  if (opts.withPrefix !== false) return `AED ${formatted}`;
  return formatted;
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const formatDateShort = (dateStr) => {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
};

export const formatDateTime = (dateStr) => {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  return `${formatDate(dateStr)} ${d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}`;
};
